import { MapDrawingConfig } from "./canvas-drawing";
import { Size } from "PosterEditor/model/poster-types";
import { PosterProject, GPSSource } from "PosterEditor/model/poster-project";
import { drawMapElements } from "./canvas-drawing";
import { defaultEditingPermissions } from "PosterEditor/model/default-project-style";
import { useSizePresets } from "PosterEditor/model/size-presets/size-preset";

export interface CanvasRenderConfig {
  map: React.MutableRefObject<any>;
  originalMapSize: Size;
  screenSize: Size;
  mapRenderSize: Size;
  borderWidthInPixels: number;
  project: PosterProject;
  gpsSource: GPSSource | undefined;
  imageCache?: Map<string, HTMLImageElement>;
}

export const getCanvasRender = async (config: CanvasRenderConfig) => {
  const offscreenCanvas = document.createElement("canvas");
  const offscreenRef = { current: offscreenCanvas }; // 👈 Wrap it

  const mapSize = config.mapRenderSize;

  offscreenCanvas.width = mapSize.width;
  offscreenCanvas.height = mapSize.height;

  const screenBorderWidth = config.borderWidthInPixels;
  const screenMapWidth = config.screenSize.width - screenBorderWidth * 2;
  const scale = mapSize.width / screenMapWidth;

  const drawingConfig: MapDrawingConfig = {
    map: config.map,
    canvasElement: offscreenRef,
    originalMapSize: config.originalMapSize,
    scale: scale,
    project: config.project,
    gpsSource: config.gpsSource,
    dotGridSpacing: undefined,
    pointerLocation: undefined,
    pointerInteruptRadius: 50,
    elementToHighlight: undefined,
    selectedElement: undefined,
    isRendering: true,
    projectEditingPermissions: defaultEditingPermissions,
    isTemplateEditing: false,
    imageCache: config.imageCache,
  };
  drawMapElements(drawingConfig);

  const blob = await new Promise<Blob>((resolve) =>
    offscreenCanvas.toBlob((b) => resolve(b!), "image/png")
  );
  return blob;
};
